import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { Typeface } from './Typeface';
import { FontSize } from './FontSize';
import { ColoredFonts } from './ColoredFonts';
import { FlexDiv, Page } from '@Main/elements';
import { PageNavigation, Margin } from '@helpers';

import { useStaticQuery, graphql } from "gatsby"

export const Typography = ({t, i18n}) => {
    i18n.loadNamespaces('typography');

    const pages = [
        {
            title: 'Typeface',
            component: Typeface,
        },
        {
            title: 'Font size',
            component: FontSize,
        },
        {
            title: 'Using colored fonts',
            component: ColoredFonts,
        },
    ];

    const data = useStaticQuery(graphql`
    {
        allFile(filter: {relativeDirectory: {eq: "typography"}}) {
            edges {
            node {
                name
                publicURL
                relativePath
            }
            }
        }
    }
    `)

    const getFileUrl = (fileName) => {
        const file = data.allFile.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node.publicURL;
    }

    return (
        <Page>
            <PageNavigation t={t} onThisPage={pages.map(page => t(`typography>${page.title}`))}/>
            <FlexDiv direction="column">
                { 
                    pages.map((page, index) => 
                        <Margin id={`block-${index + 1}`} key={page.title} marginTop={index && '50px'}>
                            {
                                React.createElement(page.component, {
                                        key: index,
                                        getFileUrl: getFileUrl,
                                        t: (text) => t(`typography>${text}`)
                                })
                            }
                        </Margin>
                    )
                }
            </FlexDiv>
        </Page>
    );
};

export const TypographyContainer = withTrans(Typography);